import { Injectable } from '@angular/core';

import { LogDeviceModel } from '../../models/log-device.model';
import { IProductsModel } from '../../models/products.model';
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { ChannelCommunicatorService } from '../communicator/channel-communicator/channel-communicator.service';
import { RequestService } from '../request/request-onboarding.service';

/**
 * Definición para que la clase sea visible desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
@Injectable({
  providedIn: 'root',
})

/**
 * Definición de la clase ProductsService, servicio para los productos
 *
 * *Defines ProductsService class, products service *
 */
export class ProductsService {

  /**
   * Constructor de la clase
   *
   * *Class Contstructor.*
   *
   * Inicializa los métodos para los servicios
   *
   * *Initialize method for services*
   *
   * @param {CopyService}    copyService    Injectable copyService service.
   * @param {RequestService} requestService Injectable abreCuentasService service.
   */
  constructor(
    private abreCuentasService: AbreCuentasService,
    private requestService: RequestService,
    private channel: ChannelCommunicatorService,
  ) { }

  /**
   * Asigna el tipo del producto
   *
   * *Assigns product type*
   *
   * @param {IProductsModel} product
   * @returns {Promise}
   */
  assignProductType(product: IProductsModel): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      this.requestService
        .assignProductType(product.product_type)
        .then(response => {
          console.log('AssignProductType: ', response);
          resolve('0');
        }, error => {
          console.log('error', error);
          reject('-1');
        });
    });
  }

  /**
   * Obtiene las ofertas de los acuerdos
   *
   * *Gets Agreements offers*
   *
   * @returns {Promise}
   */
  getAgreementsOffers(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const code = this.channel.getChannelId() === '163' ? '001' : this.abreCuentasService.getproductSelected().code;
      if (code === '201' || code === '203') {
        this.requestService
          .getAgreementsOffers()
          .then(response => {
            response.data.forEach(agreement => {
              agreement.description = `${agreement.agreement_name} - ${agreement.agreement_id}`;
            });
            this.abreCuentasService.setAgreementList(response.data);
            resolve(code);
            return;

          }, () => {
            reject('-1');
          });
        return;
      }

      resolve(code);
    });
  }
  /**
   * Obtiene las ofertas de los acuerdos de libranza
   *
   * *Gets Agreements offers*
   *
   * @returns {Promise}
   */
  async getAgreementsOffersLoan(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      console.log('solicitamos convenios');
      this.requestService
        .getAgreementsLoan()
        .then(response => {
          response.data.forEach(agreement => {
            agreement.description = agreement.client_name;
          });
          this.abreCuentasService.setAgreementList(response.data);
          resolve('200');
          return;

        }, () => {
          reject('-1');
        });
      return;
    });
  }

  /**
   * Validación de reglas
   *
   * *Rules validation*
   *
   * @param {any} rulesRq
   * @param {IProductsModel[]} products
   * @returns {Promise<IProductsModel[]}
   */
  validateRules(rulesRq: any, products: IProductsModel[]): Promise<IProductsModel[]> {
    const body = {
      rules: [
        rulesRq[0],
      ],
    };
    return new Promise<IProductsModel[]>((resolve, reject) => {
      this.requestService
        .validateRules({ data: body })
        .then(response => {
          response.data.rules_result.forEach(rule => {
            products.forEach(product => {
              if (product.visibility_rule === rule.rule_name) {
                product.active = product.active && rule.result;
              }
            });
          });
          resolve(products);
          return;
        }, () => {
          reject();
        });
    });
  }

  /**
   * Guarda el log del dispositivo en la bitácora de la apliación
   *
   * *Saves device log in app bitacora*
   *
   * @param {LogDeviceModel} devicePrint
   */
  saveDataInBitacora(devicePrint: LogDeviceModel) {
    this.requestService.saveDataInBitacora(devicePrint);
  }
  /**
   * Validación de reglas
   *
   * *Rules validation*
   *
   * @param {any} rulesRq
   * @param {IProductsModel[]} products
   * @returns {Promise<IProductsModel[]}
   */
  async offersSelectAgreement(body: any): Promise<IProductsModel[]> {
    return new Promise((resolve, reject) => {
      this.requestService.offersSelectAgreement(body)
        .then(res => {
          resolve(res);
        },
        )
        .catch(err => reject(err));
    });
  }
  /**
   * Validación de reglas
   *
   * *Rules validation*
   *
   * @param {any} rulesRq
   * @param {IProductsModel[]} products
   * @returns {Promise<IProductsModel[]}
   */
  async AgreementDetail(id: any): Promise<IProductsModel[]> {
    return new Promise((resolve, reject) => {
      this.requestService.getAgreementsLoanDetail(id)
        .then(res => {
          resolve(res);
        },
        )
        .catch(err => reject(err));
    });
  }
}
